import { render, staticRenderFns } from "./CrudMentors.vue?vue&type=template&id=1b7d2027&"
import script from "./CrudMentors.vue?vue&type=script&lang=js&"
export * from "./CrudMentors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports